import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { getUrlParameter } from './commonUtils.js';

window.next18 = i18n;
// TODO: Get this from the URL in the future 20231114:Alevale
const appId = window?.appSettings?.name || 'portal';

// will remove this check in prod to diisable translation
// const urlParams = new URLSearchParams(window.location.search);
// const myParam = urlParams.get('alohomora');
// const showTranslation = ( myParam !== 'true' ) ? 'translations' :'alohomora';

const myParam = getUrlParameter('alohomora');
const showTranslation = myParam ? 'alohomora' : 'translations';

window.t = {};
i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init(
        {
            lng: localStorage.getItem('I18N_LANGUAGE_CMS') || 'en',
            fallbackLng: false,
            react: {
                wait: true,
                useSuspense: false,
            },
            ns: 'translations',
            defaultNS: 'translations',
            backend: {
                loadPath: `/api/connect-cms/v1/${showTranslation}/apps/${appId}?locale={{lng}}&${Math.random()}`,
                crossDomain: false,
                allowMultiLoading: false,
            },
            interpolation: {
                defaultVariables: { '%2C': ',' },
                // interpolateOptions: false -- I tried to set this also
            },
            returnObjects: true,
        },
        function (err, t) {
            window.t = t;
            if (err) return console.log('something went wrong loading', err);
            t('key'); // -> same as i18next.t
        }
    );

export default i18n;
